function scrollElement(element) {
	var scrolled = window.pageYOffset || document.documentElement.scrollTop;
	var element = document.querySelector(element);
	element.style.transition = '0.3s transform linear';
	if(scrolled > element.parentNode.offsetHeight - element.offsetHeight) return;
	element.style.transform = `translateY(${scrolled}px)`;
	//console.log(123);
}

module.exports = scrollElement;


// WEBPACK FOOTER //
// ./libs/scroll-element/scroll-element.js